import React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
// import PinDropIcon from "@mui/icons-material/PinDrop";
// import NotificationsIcon from "@mui/icons-material/Notifications";
// import MarkUnreadChatAltIcon from "@mui/icons-material/MarkUnreadChatAlt";
import { useNavigate } from "react-router-dom";
import spot1 from "../../../assets/Images/spot1.png";

// For Modal
import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import { makeGetRequest } from "../../../utils/utils";
// End
import swal from "sweetalert";
import moment from "moment";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

// const rows = [
//   createData("Frozen yoghurt", 159, 6.0, 24, 4.0),
//   createData("Ice cream sandwich", 237, 9.0, 37, 4.3),
//   createData("Eclair", 262, 16.0, 24, 6.0),
//   createData("Cupcake", 305, 3.7, 67, 4.3),
//   createData("Gingerbread", 356, 16.0, 49, 3.9),
// ];

function GuardsTable() {
  const navigate = useNavigate();

  // For Modal
  const [open, setOpen] = React.useState(false);
  const [scroll] = React.useState("paper");

  // const handleClickOpen = (scrollType) => () => {
  //   setOpen(true);
  //   setScroll(scrollType);
  // };

  const handleClose = () => {
    setOpen(false);
  };

  const [allDutiesList, setAllDutiesList] = React.useState([]);

  async function getAllDuties() {
    setAllDutiesList([]);

    await makeGetRequest("guard/duties/getall/" + moment().format("YYYY-MM-DD"))
      .then((response) => {
        console.log("Guard Duties ", response);
        if (response.data.status == "1") {
          const data = response.data.data;
          setAllDutiesList(response.data.data.rows);
        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
    getAllDuties();
  }, [open]);
  // End

  return (
    <>
      <div>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 700 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell style={{ background: "#674BDD" }}>
                  Guard Name
                </StyledTableCell>
                <StyledTableCell align="left" style={{ background: "#674BDD" }}>
                  Contact Number
                </StyledTableCell>
                <StyledTableCell align="left" style={{ background: "#674BDD" }}>
                  Current Assignment
                </StyledTableCell>
                <StyledTableCell align="left" style={{ background: "#674BDD" }}>
                  Time In
                </StyledTableCell>
                <StyledTableCell align="left" style={{ background: "#674BDD" }}>
                  Time Out
                </StyledTableCell>
                {/* <StyledTableCell
                  align="center"
                  style={{ background: "#674BDD" }}
                >
                  <PinDropIcon
                    onClick={handleClickOpen("body")}
                    style={{ cursor: "pointer" }}
                  />
                </StyledTableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {allDutiesList ? (
                <>
                  {allDutiesList.map((option, index) => (
                    <StyledTableRow>
                      <StyledTableCell component="th" scope="row">
                        <p
                          className="notiFName"
                          // onClick={() => navigate("/ServiceProDetails")}
                          onClick={()=> navigate("/EditGuardNew/"+option.guard_id)}
                        >
                          {/* <div className="notiTable">
       <NotificationsIcon />
       <span>02</span>
     </div> */}
                          {option.guard_name}
                        </p>
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        <p className="guardNum">{option.contact_no}</p>
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        <p className="guardAsig">{option.spot_name}</p>
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        <p className="guardTime">
                          {moment.utc(option.start_time).format("hh:mm A")}
                        </p>
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        <p className="guardNum">05:14 pm</p>
                      </StyledTableCell>
                      {/* <StyledTableCell align="right">
                        <p className="sendSms">
                          <MarkUnreadChatAltIcon />
                        </p>
                      </StyledTableCell> */}
                    </StyledTableRow>
                  ))}
                </>
              ) : (
                <span>No Guards On Duty</span>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      <div className="modalMain">
        {/* <Button onClick={handleClickOpen("paper")}>scroll=paper</Button>
      <Button onClick={handleClickOpen("body")}>scroll=body</Button> */}
        <Dialog
          open={open}
          // onClose={handleClose}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Modal Heading Here</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <div className="mapOuter">
                <img src={spot1} />
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
}

export default GuardsTable;
